import { requestApi } from './Api';

export const getProviders = async (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/practice/member/get_practitioners',
    params,
    onError: () => {}
  });

export const getMembers = async (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/practice/member/get',
    params,
    onError: () => {}
  });

export const searchMembers = async (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/practice/member/search',
    params,
    onError: () => {}
  });

export const deleteMember = async (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/practice/member/remove',
    params
  });
export const inviteMember = async (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/practice/member/invite',
    params
  });

export const updateMember = async (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/practice/member/patch',
    params
  });

export const updateStatusMember = async (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/practice/member/update_status',
    params
  });

export const syncTrainingDelegations = async (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/practice/member/sync_training_delegations',
    params
  });
